import React from 'react';
import './Privacy.css';

const Privacy = () => {
    return (
        <div className="privacy-page">
            <div className="privacy-header">
                <h1>POLÍTICA DE PRIVACIDAD</h1>
            </div>

            <div className="container privacy-content">
                <section>
                    <p>
                        De conformidad con lo dispuesto en la normativa vigente en lo relativo a la protección de datos el Reglamento Europeo 2016/679 (RGPD) y la ley orgánica 3/2018 de protección de datos personales y garantía de los derechos digitales (LOPD) a continuación le comunicamos el tratamiento que realizamos de sus datos:
                    </p>
                </section>

                <section>
                    <h2>¿QUIÉN ES EL RESPONSABLE DEL TRATAMIENTO DE SUS DATOS?</h2>
                    <p>
                        <strong>Responsable:</strong> JAVIER VIDAL MUNIESA (a partir de ahora FISIOTERAPIA PINSEQUE)<br />
                        <strong>Domicilio social:</strong> C/ SAN PEDRO MARTIN N.º 15 LOCAL DERECHO PINSEQUE 50298 ZARAGOZA<br />
                        <strong>TLF:</strong> <a href="tel:690051174">690 05 11 74</a><br />
                        <strong>Email:</strong> <a href="mailto:info@fisioterapiapinseque.com">info@fisioterapiapinseque.com</a><br />
                        <strong>Datos de contacto delegado de protección de datos:</strong> <a href="mailto:datusmas@datusmas.com">datusmas@datusmas.com</a>
                    </p>
                </section>

                <section>
                    <h2>¿CON QUÉ FINALIDAD TRATAMOS SUS DATOS PERSONALES?</h2>
                    <h3>SUS DATOS PERSONALES SÓLO SE UTILIZARÁN PARA LAS SIGUIENTES FINALIDADES, LEGITIMACIONES Y TIEMPO DE CONSERVACION:</h3>

                    <div className="subsection">
                        <h4>Como Usuario de la Web</h4>
                        <p>
                            Tus datos serán utilizados para dar respuestas a tus solicitudes de información, comentarios o sugerencias, a través del apartado de contacto o de las direcciones de correo que aparezcan en nuestra página y mantener la comunicación con el interesado.
                        </p>
                        <p><strong>Legitimación:</strong> Consentimiento/solicitud de medidas precontractuales (solicitud de información concreta sobre nuestros servicios en fisioterapia) conforme a los Art. 6.1.a) y Art.6.1. b) del RGPD respectivamente.</p>
                        <p><strong>Conservación:</strong> Conservados hasta cumplir su finalidad o hasta que nos revoque el consentimiento prestado.</p>
                    </div>

                    <div className="subsection">
                        <h4>Como seguidor en Redes Sociales</h4>
                        <p>
                            Utilizamos redes sociales para informar sobre nuestras actividades e interactuar con nuestros seguidores. Al hacerte seguidor nuestro, consientes que trate los datos personales que estén disponibles en tu perfil, exclusivamente para dicha finalidad y sólo en el entorno de cada red social conforme a sus políticas de uso y privacidad.
                        </p>
                        <p><strong>Legitimación:</strong> Tratamiento realizado en base al consentimiento del interesado Art. 6.1.a) del RGPD.</p>
                        <p><strong>Conservación:</strong> Serán conservados hasta que nos revoque el consentimiento prestado o dejes de seguirnos o marques ya no me gusta.</p>
                    </div>

                    <div className="subsection">
                        <h4>Como Paciente</h4>
                        <p>
                            Tus datos serán utilizados para gestionar el tratamiento o la consulta fisioterapéutica que nos solicita y de las tareas administrativas derivadas de la prestación asistencial.
                        </p>
                        <p><strong>Legitimación:</strong> La ejecución de un contrato para la prestación de la asistencia Fisioterapéutica que nos solicita (artículo 6.1.b RGPD) y su tratamiento sea realizado por un profesional sujeto a la obligación de secreto profesional (artículo 9.3 RGPD).</p>
                        <p><strong>Conservación:</strong> Un mínimo de Cinco años conservaré los datos personales incluidos en su historia clínica a contar desde la fecha de alta de cada proceso asistencial, de acuerdo con la Ley 41/2002 de autonomía del paciente.</p>
                    </div>

                    <div className="subsection">
                        <h4>Como proveedor</h4>
                        <p>
                            Tus datos serán utilizados para gestionar la relación como proveedor de nuestra empresa, así como la gestión económica derivada.
                        </p>
                        <p><strong>Legitimación:</strong> En base a la relación contractual Art.6.1. b) y cumplimiento de obligaciones legales en el ámbito económico y fiscal Art. 6.1.c) del RGPD.</p>
                        <p><strong>Conservación:</strong> Cuatro Años a efectos fiscales. Seis años a efectos mercantiles.</p>
                    </div>
                </section>

                <section>
                    <h2>¿HAY OBLIGACIÓN DE FACILITAR ESOS DATOS PERSONALES?</h2>
                    <p>En el contacto solicitado, se hace necesario que nos facilite algunos datos de contacto para poder dirigirnos a usted para poder prestarle el servicio que nos solicita.</p>
                </section>

                <section>
                    <h2>¿CUÁLES SON LAS CONSECUENCIAS DE NO HACERLO?</h2>
                    <p>Si no nos facilita los datos mínimos de contacto no será imposible e inviable atenderle.</p>
                </section>

                <section>
                    <h2>¿CÓMO HE OBTENIDOS SUS DATOS PERSONALES?</h2>
                    <p>Los datos obtenidos nos los ha proporcionado usted directamente.</p>
                </section>

                <section>
                    <h2>¿A QUÉ DESTINATARIOS SE COMUNICARÁN SUS DATOS PERSONALES?</h2>
                    <p>No existe ninguna cesión de datos prevista, salvo obligación legal.</p>
                </section>

                <section>
                    <h2>¿CUÁLES SON SUS DERECHOS CUANDO ME FACILITA SUS DATOS PERSONALES?</h2>
                    <p>Cualquier interesado podrá solicitar el ejercicio de los siguientes derechos:</p>
                    <ul>
                        <li><strong>Derecho de acceso:</strong> El interesado tendrá derecho a obtener confirmación de si se están tratando o no datos personales que le conciernen.</li>
                        <li><strong>Derecho de rectificación:</strong> El interesado tendrá derecho a obtener la rectificación de los datos personales inexactos que le conciernan o incompletos.</li>
                        <li><strong>Derecho de supresión:</strong> El interesado tendrá derecho a obtener la supresión de los datos personales que le conciernan cuando los datos personales ya no sean necesarios.</li>
                        <li><strong>Derecho de limitación:</strong> Podrá solicitar la limitación del tratamiento de sus datos personales.</li>
                        <li><strong>Derecho a la portabilidad:</strong> Puede solicitarnos que sus datos personales automatizados sean cedidos o transferidos a cualquier otra empresa.</li>
                        <li><strong>Derecho de retirar el consentimiento:</strong> Usted tendrá derecho a retirar el consentimiento en cualquier momento.</li>
                        <li><strong>Derecho de oposición:</strong> El interesado tendrá derecho a oponerse al tratamiento de sus datos.</li>
                    </ul>
                </section>

                <section>
                    <h2>¿CÓMO PODRÁ EJERCITAR ESTOS DERECHOS?</h2>
                    <p>
                        Ponemos a su disposición si nos lo solicitan los formularios donde podrá ejercitar estos derechos. Podrá solicitarnos en el correo <a href="mailto:info@fisioterapiapinseque.com">info@fisioterapiapinseque.com</a> indicándonos el derecho que quiere ejercitar y le enviaremos el formulario correspondiente.
                    </p>
                    <p>
                        Los derechos de los interesados son personalísimos, por lo tanto, serán ejercidos por el titular de los datos acreditando debidamente su identidad (para ello se le solicitará el DNI o equivalente).
                    </p>
                </section>

                <section>
                    <h2>DERECHO DE RECLAMACIÓN A LA AUTORIDAD DE CONTROL</h2>
                    <p>
                        Usted, podrá solicitar la tutela de derechos que no hayan sido debidamente atendidos a la Agencia Española de Protección de datos. Bien a través de la sede electrónica de su portal web (<a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a>), o bien mediante escrito dirigido a su dirección postal (C/Jorge Juan, 6, 28001-Madrid).
                    </p>
                </section>

                <section>
                    <h2>¿QUÉ INFORMACIÓN RECOPILAMOS?</h2>
                    <p>
                        En general, puede usar el Sitio Web sin facilitar ninguna información de carácter personal. Existen canales en nuestra página web donde se puede poner en contacto con nosotros. Cuando nos solicita información, el usuario garantiza la autenticidad, exactitud y veracidad de toda la información que nos facilite.
                    </p>
                </section>

                <section>
                    <h2>¿QUÉ MEDIDAS ADOPTAMOS PARA MANTENER SEGURA SU INFORMACIÓN?</h2>
                    <p>Aplicamos medidas técnicas y físicas razonables para proteger la información que recogemos a través del Sitio Web.</p>
                </section>

                <section>
                    <h2>MODIFICACIONES DE LA PRESENTE INFORMACIÓN DE PROTECCION DE DATOS</h2>
                    <p>FISIOTERAPIA PINSEQUE se reserva el derecho a modificar su Política de Protección de datos de acuerdo con la legislación aplicable en cada momento. Cualquier modificación de dicha política será publicada en el sitio web.</p>
                </section>
            </div>
        </div>
    );
};

export default Privacy;
